

import {
  createSelector
} from 'reselect';

import { getSelectedAttrs } from './general';

const getExcludedFromCompatibility = () => (
  {
    collar: {
      collarButtonDown: {
        'collarBone': true,
        'collarButtons': true,
        'collarDensity': [
          'true',
        ]
      },
      collarButtonDownMini: {
        'collarBone': true,
        'collarButtons': true,
        'collarDensity': [
          'true',
        ]
      },
      collarVintageClub: {
        'collarBone': true,
        'collarButtons': true,
      },
      collarVintageClubMini: {
        'collarBone': true,
        'collarButtons': true,
      },
      collarMao: {
        'collarBone': true,
        'collarButtons': true,
      },
      collarMandarin: {
        'collarBone': true,
        'collarButtons': true,
      },
      collarWingTip: {
        'collarBone': true,
        'collarButtons': true,
        'collarDensity': [
          'soft',
        ]
      },
    },
    collarBone: {
      'true': {
        'collar': [
          'collarButtonDown',
          'collarButtonDownMini',
          'collarVintageClub',
          'collarVintageClubMini',
          'collarMao',
          'collarMandarin',
          'collarWingTip',
        ],
        'collarButtons': true,
      },
    },
    collarButtons: {
      'true': {
        'collar': [
          'collarButtonDown',
          'collarButtonDownMini',
          'collarVintageClub',
          'collarVintageClubMini',
          'collarMao',
          'collarMandarin',
          'collarWingTip',
        ],
        'collarBone': true,
      },
    },
    collarDensity: {
      'true': { //Жесткая
        'collar': [
          'collarButtonDown',
          'collarButtonDownMini',
        ]
      },
      'soft': { //Мягкая
        'collar': [
          'collarWingTip',
        ]
      },
      'false': { //Средняя
        'collar': []
      },
    },
    sleeve: {
      'sleeveShort': {
        'cuffDecor': true,
        'cuff': [
          'cuffOneButton',
          'cuffRegulated',
          'cuffTwoButtons',
          'cuffLinksWien',
          'cuffLinksSingle',
          'cuffFrench',
        ],
        'cuffDensity': [
          'soft',
          'medium',
          'hard'
        ],
        'cuffStyle': [
          'cuffStyleStraight',
          'cuffStyleTruncated',
          'cuffStyleRound',
          'cuffStyleOriginal',
        ],
        'cuffDecor': true,
        'cuffFabric': true,
        'cuffTurnFabric': true,
        'embroidery': [
          'embroideryAtCuff',
          'embroideryAtCuffRight'
        ]
      },
      'sleeveShortCuff': {
        'cuffDecor': true,
        'cuff': [
          'cuffOneButton',
          'cuffRegulated',
          'cuffTwoButtons',
          'cuffLinksWien',
          'cuffLinksSingle',
          'cuffFrench',
        ],
        'cuffDensity': [
          'soft',
          'false', //Средняя
          'true' //Жесткая
        ],
        'cuffStyle': [
          'cuffStyleStraight',
          'cuffStyleTruncated',
          'cuffStyleRound',
          'cuffStyleOriginal',
        ],
        'cuffDecor': true,
        'cuffFabric': true,
        'cuffTurnFabric': true,
        'embroidery': [
          'embroideryAtCuff',
          'embroideryAtCuffRight'
        ]
      },
    },
    cuff: {
      'cuffOneButton': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ],
      },
      'cuffRegulated': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ],
      },
      'cuffTwoButtons': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ],
      },
      'cuffLinksWien': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ],
      },
      'cuffLinksSingle': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ],
      },
      'cuffFrench': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ],
        'cuffDensity': [
          'soft',
          'true'
        ],
      },
    },
    cuffDensity: {
      'true': { //Жесткая
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ],
        'cuff': [
          'cuffFrench',
        ],
      },
      'soft': { //Мягкая
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ],
        'cuff': [
          'cuffFrench',
        ],
      },
      'false': { //Средняя
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ]
      },
    },
    cuffStyle: {
      'cuffStyleStraight': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ]
      },
      'cuffStyleTruncated': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ]
      },
      'cuffStyleRound': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ]
      },
      'cuffStyleOriginal': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ]
      },
    },
    suspended: {
      'true': {
        'buttonThreadDecor': true
      },
    },
    buttonThreadDecor: {
      'true': {
        'suspended': true
      },
    },
    cuffDecor: {
      'true': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ]
      }
    },
    cuffFabric: {
      'true': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ]
      }
    },
    pocketButton: {
      'true': {
        'pocket': [
          'pocketNone',
        ]
      }
    },
    pocketFlap: {
      'true': {
        'pocket': [
          'pocketNone',
        ]
      }
    },
    pocket: {
      'pocketNone': {
        'pocketFlap': true,
        'pocketButton': true,
        'embroidery': [
          'embroideryAtPocket'
        ]
      },
      'pocketFlap': {
        pocket: {
          'pocketNone': true,
        },
      },
      'pocketButton': {
        pocket: {
          'pocketNone': true,
        },
      },
    },
    embroidery: {
      'embroideryAtCuff': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ],
      },
      'embroideryAtCuffRight': {
        'sleeve': [
          'sleeveShort',
          'sleeveShortCuff',
        ],
      },
      'embroideryAtPocket': {
        'pocket': [
          'pocketNone',
        ]
      }
    },
    // buttons: {
    //   'buttons': {
    //     '1-5': {
    //       suspended: true,
    //     }
    //   }
    // }
  }
)

export const MakeGetCompatibility = (attr) => {

  return createSelector(
    getSelectedAttrs,
    getExcludedFromCompatibility,
    (attrs, excluded) => {
      let result = false;
      for (let attrName in attrs) {
        const attrValue = attrs[attrName].attrValue;
        if (
          excluded.hasOwnProperty(attrName) &&
          excluded[attrName].hasOwnProperty(attrValue)
        ) {
          const disabledRule = excluded[attrName][attrValue];
          if(disabledRule[attr]){
            const val = disabledRule[attr];
            if(Array.isArray(val)){
              if(!result) {
                result = val;
              } else {
                result.push(...val)
              }
            } else {
              result = val;
            }
          }
        }
      }
      return result;
    }
  )
}